module.exports = __webpack_public_path__ + "static/media/Barlow-Medium.6fcea11e.ttf";